import styled from 'styled-components'
import { rem } from 'polished'
import React from 'react'
import LayoutContainer from 'components/Common/LayoutContainer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import useIsAvailableForPurchase from '../hooks/useIsAvailableForPurchase'
import { NavWrapper } from 'components/OfferPage/styles'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import TextButton from 'components/Luxkit/Button/TextButton'
import BodyText from 'components/Luxkit/Typography/BodyText'
import DesktopRelatedTravelItems from 'components/OfferPage/RelatedTravelItems'
import config from 'constants/config'
import cx from 'clsx'

const Container = styled(NavWrapper)`
  flex: 1;

  &.hideOnMobile.hideOnMobile {
    display: none;
    ${mediaQueryUp.tablet} {
      display: flex;
      visibility: visible;
    }
  }
`
const Root = styled(LayoutContainer)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;

  ${mediaQueryUp.tablet} {
    margin-left: auto;
  }

  > * + * {
    margin-left: ${rem(12)};
  }

`

const MobileNewLine = styled.br`
  ${mediaQueryUp.tablet} {
    display: none;
  }
`

const InlineWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > * + * {
    margin-left: ${rem(8)};
  }

  ${mediaQueryUp.tablet} {
    justify-content: flex-end;
  }
`

interface Props {
  offer: App.HotelOffer;
  headlessMode: boolean;
}

function LastMinuteOfferPageStickyFooter(props: Props) {
  const {
    offer,
    headlessMode,
  } = props

  const availableForPurchase = useIsAvailableForPurchase()

  const displaySoldOutLabel = !availableForPurchase && !config.LERE_EXPIRED_DEALS_V2_ENABLED
  const hideSoldOutOnMobile = !availableForPurchase && config.LERE_EXPIRED_DEALS_V2_ENABLED

  return (
    <Container className={cx({ hideOnMobile: hideSoldOutOnMobile })}>
      <Root>
        {!headlessMode && <DesktopRelatedTravelItems offer={offer} />}
        {displaySoldOutLabel &&
          <InlineWrapper>
            <BodyText variant="medium" weight="bold" colour="neutral-one">
              This offer has<MobileNewLine /> SOLD OUT
            </BodyText>
            <TextButton kind="primary" to="/">
              Browse all offers
            </TextButton>
          </InlineWrapper>
        }
      </Root>
    </Container>
  )
}

export default withOfferPageAndReduxState((state, appState) => ({
  headlessMode: appState.system.headlessMode,
}), LastMinuteOfferPageStickyFooter)
